__webpack_require__.p = "/library/animations/periodic-table/";